webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _stringify = __webpack_require__(192);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	__webpack_require__(232);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(294);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(293);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueCookie = __webpack_require__(236);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	var _vuePagination = __webpack_require__(292);
	
	var _i18n = __webpack_require__(26);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _App = __webpack_require__(238);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Pages = __webpack_require__(149);
	
	var AllPages = _interopRequireWildcard(_Pages);
	
	var _Post = __webpack_require__(148);
	
	var Post = _interopRequireWildcard(_Post);
	
	var _store = __webpack_require__(155);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _SimpleUi = __webpack_require__(154);
	
	var _SimpleUi2 = _interopRequireDefault(_SimpleUi);
	
	var _Breadcrumbs = __webpack_require__(151);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _DocumentTitle = __webpack_require__(153);
	
	var _DocumentTitle2 = _interopRequireDefault(_DocumentTitle);
	
	var _Bus = __webpack_require__(152);
	
	var _Bus2 = _interopRequireDefault(_Bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_SimpleUi2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueCookie2.default);
	_vue2.default.use(_Breadcrumbs2.default);
	_vue2.default.use(_DocumentTitle2.default, {
	  mainTitle: 'vue-lab',
	  separator: ' ' + String.fromCharCode('9749') + ' '
	});
	_vue2.default.use(_Bus2.default);
	_vue2.default.use(_vuePagination.VuePagination, true);
	
	_i18n2.default.install();
	
	var apiRoot = 'https://api.vue.thiagosf.net';
	if (false) {
	  apiRoot = 'http://api.dev.azk.io';
	}
	_vue2.default.http.options.root = apiRoot;
	
	var router = new _vueRouter2.default({
	  hashbang: false,
	  mode: 'history',
	  base: __dirname,
	  routes: [{
	    path: '/',
	    name: 'home',
	    component: AllPages.Home,
	    meta: { requiresAuth: true }
	  }, {
	    path: '/login',
	    name: 'login',
	    component: AllPages.Login
	  }, {
	    path: '/logout',
	    name: 'logout',
	    beforeEnter: function beforeEnter(to, from, next) {
	      _store2.default.dispatch('logout');
	      next({ name: 'login' });
	    }
	  }, {
	    path: '/register',
	    name: 'register',
	    component: AllPages.Register,
	    meta: { requiresAuth: true }
	  }, {
	    path: '/about',
	    name: 'about',
	    component: AllPages.About,
	    meta: { requiresAuth: true }
	  }, {
	    path: '/table',
	    name: 'table',
	    component: AllPages.Table,
	    meta: { requiresAuth: true }
	  }, {
	    path: '/posts',
	    component: Post.Post,
	    meta: { requiresAuth: true, alias: 'posts' },
	    children: [{
	      path: '',
	      name: 'posts',
	      component: Post.PostList
	    }, {
	      path: 'new',
	      name: 'new-post',
	      component: Post.NewPost
	    }, {
	      path: ':id/edit',
	      name: 'edit-post',
	      component: Post.EditPost
	    }]
	  }, {
	    path: '*',
	    component: AllPages.PageNotFound,
	    meta: { requiresAuth: true }
	  }]
	});
	
	router.beforeEach(function (to, from, next) {
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  })) {
	    if (!_store2.default.getters.loggedIn) {
	      next({
	        name: 'login',
	        query: { redirect: to.name, params: (0, _stringify2.default)(to.params) }
	      });
	    } else {
	      next();
	    }
	  } else {
	    next();
	  }
	});
	
	_vue2.default.router = router;
	_App2.default.store = _store2.default;
	_App2.default.router = _vue2.default.router;
	new _vue2.default(_App2.default).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uiComponent = undefined;
	
	var _uiComponent2 = __webpack_require__(147);
	
	var _uiComponent3 = _interopRequireDefault(_uiComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.uiComponent = _uiComponent3.default;

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefix = 'vuelab';
	
	var SEND_NEWSLETTER = exports.SEND_NEWSLETTER = prefix + '/SEND_NEWSLETTER';
	
	var LOGIN = exports.LOGIN = prefix + '/LOGIN';
	var SUCCESS_TOKEN = exports.SUCCESS_TOKEN = prefix + '/SUCCESS_TOKEN';
	var INVALID_TOKEN = exports.INVALID_TOKEN = prefix + '/INVALID_TOKEN';
	var LOGOUT = exports.LOGOUT = prefix + '/LOGOUT';
	
	var NOTIFY = exports.NOTIFY = prefix + '/NOTIFY';
	
	var SET_LOCALE = exports.SET_LOCALE = prefix + '/SET_LOCALE';
	
	var TRANSITION_NAME = exports.TRANSITION_NAME = prefix + '/TRANSITION_NAME';
	var TRANSITION_MODE = exports.TRANSITION_MODE = prefix + '/TRANSITION_MODE';
	
	var SET_BREADCRUMB = exports.SET_BREADCRUMB = prefix + '/SET_BREADCRUMB';
	
	var SET_POSTS = exports.SET_POSTS = prefix + '/SET_POSTS';
	var SET_POST = exports.SET_POST = prefix + '/SET_POST';
	var CREATED_POST = exports.CREATED_POST = prefix + '/CREATED_POST';
	var UPDATED_POST = exports.UPDATED_POST = prefix + '/UPDATED_POST';
	var CLEAN_POST = exports.CLEAN_POST = prefix + '/CLEAN_POST';
	var CLEAN_POSTS = exports.CLEAN_POSTS = prefix + '/CLEAN_POSTS';
	var POST_PAGINATE = exports.POST_PAGINATE = 'post/PAGINATE';

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UiCheckbox = exports.UiDialog = exports.UiSpinner = exports.UiFloatingBox = exports.UiModuleHeader = exports.UiTextArea = exports.UiText = exports.UiNav = exports.UiLayout = exports.UiLabel = exports.UiIcon = exports.UiHeader = exports.UiGridRow = exports.UiGrid = exports.UiFieldGroup = exports.UiContent = exports.UiButton = undefined;
	
	var _UiButton2 = __webpack_require__(13);
	
	var _UiButton3 = _interopRequireDefault(_UiButton2);
	
	var _UiContent2 = __webpack_require__(249);
	
	var _UiContent3 = _interopRequireDefault(_UiContent2);
	
	var _UiFieldGroup2 = __webpack_require__(142);
	
	var _UiFieldGroup3 = _interopRequireDefault(_UiFieldGroup2);
	
	var _UiGrid2 = __webpack_require__(252);
	
	var _UiGrid3 = _interopRequireDefault(_UiGrid2);
	
	var _UiGridRow2 = __webpack_require__(143);
	
	var _UiGridRow3 = _interopRequireDefault(_UiGridRow2);
	
	var _UiHeader2 = __webpack_require__(253);
	
	var _UiHeader3 = _interopRequireDefault(_UiHeader2);
	
	var _UiIcon2 = __webpack_require__(23);
	
	var _UiIcon3 = _interopRequireDefault(_UiIcon2);
	
	var _UiLabel2 = __webpack_require__(144);
	
	var _UiLabel3 = _interopRequireDefault(_UiLabel2);
	
	var _UiLayout2 = __webpack_require__(254);
	
	var _UiLayout3 = _interopRequireDefault(_UiLayout2);
	
	var _UiNav2 = __webpack_require__(256);
	
	var _UiNav3 = _interopRequireDefault(_UiNav2);
	
	var _UiText2 = __webpack_require__(145);
	
	var _UiText3 = _interopRequireDefault(_UiText2);
	
	var _UiTextArea2 = __webpack_require__(257);
	
	var _UiTextArea3 = _interopRequireDefault(_UiTextArea2);
	
	var _UiModuleHeader2 = __webpack_require__(255);
	
	var _UiModuleHeader3 = _interopRequireDefault(_UiModuleHeader2);
	
	var _UiFloatingBox2 = __webpack_require__(251);
	
	var _UiFloatingBox3 = _interopRequireDefault(_UiFloatingBox2);
	
	var _UiSpinner2 = __webpack_require__(14);
	
	var _UiSpinner3 = _interopRequireDefault(_UiSpinner2);
	
	var _UiDialog2 = __webpack_require__(250);
	
	var _UiDialog3 = _interopRequireDefault(_UiDialog2);
	
	var _UiCheckbox2 = __webpack_require__(141);
	
	var _UiCheckbox3 = _interopRequireDefault(_UiCheckbox2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UiButton = _UiButton3.default;
	exports.UiContent = _UiContent3.default;
	exports.UiFieldGroup = _UiFieldGroup3.default;
	exports.UiGrid = _UiGrid3.default;
	exports.UiGridRow = _UiGridRow3.default;
	exports.UiHeader = _UiHeader3.default;
	exports.UiIcon = _UiIcon3.default;
	exports.UiLabel = _UiLabel3.default;
	exports.UiLayout = _UiLayout3.default;
	exports.UiNav = _UiNav3.default;
	exports.UiText = _UiText3.default;
	exports.UiTextArea = _UiTextArea3.default;
	exports.UiModuleHeader = _UiModuleHeader3.default;
	exports.UiFloatingBox = _UiFloatingBox3.default;
	exports.UiSpinner = _UiSpinner3.default;
	exports.UiDialog = _UiDialog3.default;
	exports.UiCheckbox = _UiCheckbox3.default;

/***/ },
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (field, value) {
	  switch (field) {
	    case 'created_at':
	      value = (0, _moment2.default)(value).format('DD/MM/YYYY');
	      break;
	  }
	  return value;
	};

/***/ },
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(175)
	
	/* template */
	var __vue_template__ = __webpack_require__(284)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(189)
	
	/* template */
	var __vue_template__ = __webpack_require__(260)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toast = exports.errorHandler = exports.i18n = undefined;
	
	var _i18n2 = __webpack_require__(26);
	
	var _i18n3 = _interopRequireDefault(_i18n2);
	
	var _error_handler = __webpack_require__(25);
	
	var _error_handler2 = _interopRequireDefault(_error_handler);
	
	var _toast2 = __webpack_require__(16);
	
	var _toast3 = _interopRequireDefault(_toast2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.i18n = _i18n3.default;
	exports.errorHandler = _error_handler2.default;
	exports.toast = _toast3.default;

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	window.addEventListener('load', function () {
	  window.MaterialSnackbar.prototype.setMessage = function (message) {
	    this.textElement_.textContent = message;
	  };
	});
	
	exports.default = {
	  show: function show(message) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
	    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4000;
	
	    message = message.replace(/(<([^>]+)>)/ig, '');
	    var snackbar = document.querySelector('#snackbar-message');
	    if (snackbar.MaterialSnackbar) {
	      if (snackbar.className.indexOf('mdl-snackbar--active') === -1) {
	        snackbar.MaterialSnackbar.showSnackbar({ message: message, timeout: timeout });
	      } else {
	        snackbar.MaterialSnackbar.setMessage(message);
	      }
	    }
	  }
	};

/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(167)
	
	/* template */
	var __vue_template__ = __webpack_require__(262)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(184)
	
	/* template */
	var __vue_template__ = __webpack_require__(281)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 24 */,
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toast = __webpack_require__(16);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (error) {
	  console.log(error);
	  if (error.message) {
	    _toast2.default.show(error.message, 'error');
	  } else if (error.body) {
	    _toast2.default.show(error.body, 'error');
	  } else if (error.statusText) {
	    _toast2.default.show(error.statusText, 'error');
	  } else {
	    _toast2.default.show('Erro desconhecido. Status = ' + error.status, 'error');
	  }
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(237);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _locales = __webpack_require__(150);
	
	var allLocales = _interopRequireWildcard(_locales);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  default: 'pt-BR',
	  fallbackLanguage: 'en',
	  install: function install() {
	    _vue2.default.use(_vueI18n2.default);
	
	    this.locales().forEach(function (item) {
	      _vue2.default.locale(item.locale, allLocales[item.file]);
	    });
	
	    _vue2.default.config.fallbackLanguage = this.fallbackLanguage;
	    this.locale(this.default);
	  },
	  locales: function locales(all) {
	    var items = [{
	      name: 'Português',
	      locale: 'pt-BR',
	      file: 'ptBR',
	      enabled: true
	    }, {
	      name: 'English',
	      locale: 'en',
	      file: 'en',
	      enabled: true
	    }, {
	      name: 'Español',
	      locale: 'es',
	      file: 'es',
	      enabled: true
	    }];
	    if (!all) {
	      return items.filter(function (item) {
	        return item.enabled;
	      });
	    } else {
	      return items;
	    }
	  },
	  locale: function locale(_locale) {
	    if (_locale) {
	      _vue2.default.config.lang = _locale;
	    } else {
	      return _vue2.default.config.lang;
	    }
	  },
	  localeItem: function localeItem(locale) {
	    if (!locale) locale = this.default;
	    return this.locales().filter(function (item) {
	      return item.locale === locale;
	    }).shift();
	  },
	  defaultLocaleItem: function defaultLocaleItem() {
	    return this.localeItem(this.locale());
	  }
	};

/***/ },
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(176)
	
	/* template */
	var __vue_template__ = __webpack_require__(266)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(179)
	
	/* template */
	var __vue_template__ = __webpack_require__(261)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(182)
	
	/* template */
	var __vue_template__ = __webpack_require__(265)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(185)
	
	/* template */
	var __vue_template__ = __webpack_require__(272)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(190)
	
	/* template */
	var __vue_template__ = __webpack_require__(283)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 146 */,
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  mounted: function mounted() {
	    this.$upgradeElement();
	  }
	};

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postConverter = exports.PostForm = exports.EditPost = exports.NewPost = exports.PostList = exports.Post = undefined;
	
	var _Post2 = __webpack_require__(241);
	
	var _Post3 = _interopRequireDefault(_Post2);
	
	var _PostList2 = __webpack_require__(242);
	
	var _PostList3 = _interopRequireDefault(_PostList2);
	
	var _NewPost2 = __webpack_require__(240);
	
	var _NewPost3 = _interopRequireDefault(_NewPost2);
	
	var _EditPost2 = __webpack_require__(239);
	
	var _EditPost3 = _interopRequireDefault(_EditPost2);
	
	var _PostForm2 = __webpack_require__(22);
	
	var _PostForm3 = _interopRequireDefault(_PostForm2);
	
	var _converter = __webpack_require__(11);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Post = _Post3.default;
	exports.PostList = _PostList3.default;
	exports.NewPost = _NewPost3.default;
	exports.EditPost = _EditPost3.default;
	exports.PostForm = _PostForm3.default;
	exports.postConverter = _converter2.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Table = exports.Register = exports.PageNotFound = exports.Login = exports.Home = exports.About = undefined;
	
	var _About2 = __webpack_require__(243);
	
	var _About3 = _interopRequireDefault(_About2);
	
	var _Home2 = __webpack_require__(244);
	
	var _Home3 = _interopRequireDefault(_Home2);
	
	var _Login2 = __webpack_require__(245);
	
	var _Login3 = _interopRequireDefault(_Login2);
	
	var _PageNotFound2 = __webpack_require__(246);
	
	var _PageNotFound3 = _interopRequireDefault(_PageNotFound2);
	
	var _Register2 = __webpack_require__(247);
	
	var _Register3 = _interopRequireDefault(_Register2);
	
	var _Table2 = __webpack_require__(248);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.About = _About3.default;
	exports.Home = _Home3.default;
	exports.Login = _Login3.default;
	exports.PageNotFound = _PageNotFound3.default;
	exports.Register = _Register3.default;
	exports.Table = _Table3.default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.es = exports.en = exports.ptBR = undefined;
	
	var _ptBR2 = __webpack_require__(230);
	
	var _ptBR3 = _interopRequireDefault(_ptBR2);
	
	var _en2 = __webpack_require__(228);
	
	var _en3 = _interopRequireDefault(_en2);
	
	var _es2 = __webpack_require__(229);
	
	var _es3 = _interopRequireDefault(_es2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ptBR = _ptBR3.default;
	exports.en = _en3.default;
	exports.es = _es3.default;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperties = __webpack_require__(193);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function plugin(Vue) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _defineProperties2.default)(Vue.prototype, {
	    $breadcrumbs: {
	      get: function get() {
	        var _this = this;
	
	        var crumbs = [];
	        crumbs = [{ breadcrumb: 'Dashboard', name: 'home' }].concat(crumbs);
	
	        var _loop = function _loop(i) {
	          var crumb = null;
	          var item = _this.$route.matched[i];
	          var name = item.name;
	          if (!name && item.meta.alias) name = item.meta.alias;
	          if (item.components && item.components.default) {
	            if (item.components.default.breadcrumb) {
	              crumb = {
	                breadcrumb: item.components.default.breadcrumb,
	                name: name
	              };
	            } else if (item.components.default.title) {
	              crumb = {
	                breadcrumb: item.components.default.title,
	                name: name
	              };
	            }
	          }
	          if (crumb) {
	            if (!crumbs.some(function (e) {
	              return e.breadcrumb === crumb.breadcrumb;
	            })) {
	              crumbs.push(crumb);
	            }
	          }
	        };
	
	        for (var i in this.$route.matched) {
	          _loop(i);
	        }
	        if (crumbs.length) {
	          crumbs[crumbs.length - 1].active = true;
	        }
	        return crumbs;
	      }
	    }
	  });
	
	  Vue.component('breadcrumbs', {
	    template: '\n      <nav class="breadcrumbs" v-if="$breadcrumbs.length">\n        <ul>\n          <li v-for="crumb in $breadcrumbs" :class="{ active: crumb.active }" v-bind:key="crumb.breadcrumb">\n            <router-link v-if="!crumb.active" :to="{ name: crumb.name }">{{ crumb.breadcrumb }}</router-link>\n            <span v-if="crumb.active">{{ crumb.breadcrumb }}</span>\n          </li>\n        </ul>\n      </nav>'
	  });
	}
	
	plugin.version = '1.0.0';
	
	exports.default = plugin;

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Bus = {
	  version: '1.0.0',
	  install: function install(Vue, options) {
	    Vue.prototype.$bus = new Vue({});
	  }
	};
	
	exports.default = Bus;

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DocumentTitle = {
	  version: '1.0.0',
	  install: function install(Vue, options) {
	    Vue.prototype.$refreshDocumentTitle = function () {
	      var item = this.$route.matched[this.$route.matched.length - 1];
	      if (item && item.components && item.components.default && item.components.default.title) {
	        var titles = [];
	        titles.push(item.components.default.title);
	        if (options.mainTitle) {
	          titles.push(options.mainTitle);
	        }
	        this.$setDocumentTitle(titles);
	      }
	    };
	    Vue.prototype.$setDocumentTitle = function (title) {
	      document.title = Array.isArray(title) ? title.join(options.separator) : title;
	    };
	  }
	};
	
	exports.default = DocumentTitle;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UiIcon = __webpack_require__(23);
	
	var _UiIcon2 = _interopRequireDefault(_UiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleUi = {
	  version: '1.0.0',
	  install: function install(Vue, options) {
	    Vue.component('ui-title', {
	      template: '<h1 :class="cssClasses"><ui-icon v-if="icon" rounded size="48" :name="icon" /> <slot></slot></h1>',
	      components: { UiIcon: _UiIcon2.default },
	      computed: {
	        cssClasses: function cssClasses() {
	          return {
	            'main-title': true,
	            'title-with-icon': this.icon
	          };
	        }
	      },
	      props: {
	        icon: String
	      }
	    });
	    Vue.component('ui-second-title', {
	      template: '<h2 :class="cssClasses"><span><ui-icon v-if="icon" rounded size="48" :name="icon" /> <slot></slot></span></h2>',
	      components: { UiIcon: _UiIcon2.default },
	      computed: {
	        cssClasses: function cssClasses() {
	          return {
	            'second-title': true,
	            'title-with-icon': this.icon
	          };
	        }
	      },
	      props: {
	        icon: String
	      }
	    });
	
	    Vue.prototype.$defaultEnterTransition = function () {
	      document.querySelector('.mdl-layout__content').scrollTop = 0;
	      Vue.prototype.$upgradeDom();
	    };
	    Vue.prototype.$upgradeDom = function () {
	      window.componentHandler.upgradeDom();
	    };
	    Vue.prototype.$upgradeElement = function () {
	      window.componentHandler.upgradeElement(this.$el);
	    };
	  }
	};
	
	exports.default = SimpleUi;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _user = __webpack_require__(162);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _newsletter = __webpack_require__(158);
	
	var _newsletter2 = _interopRequireDefault(_newsletter);
	
	var _notification = __webpack_require__(159);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _i18n = __webpack_require__(156);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _transition = __webpack_require__(161);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _nav = __webpack_require__(157);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _post = __webpack_require__(160);
	
	var _post2 = _interopRequireDefault(_post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: [_user2.default, _newsletter2.default, _notification2.default, _i18n2.default, _transition2.default, _nav2.default, _post2.default]
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  i18n: {
	    current: _helpers.i18n.defaultLocaleItem(),
	    locales: _helpers.i18n.locales()
	  }
	};
	
	var getters = {
	  getCurrentLocale: function getCurrentLocale(state) {
	    return state.i18n.current;
	  },
	  getLocales: function getLocales(state) {
	    return state.i18n.locales.map(function (item) {
	      return (0, _assign2.default)({}, item, {
	        active: item.locale === state.i18n.current.locale
	      });
	    });
	  }
	};
	
	var actions = {
	  setLocale: function setLocale(_ref, locale) {
	    var commit = _ref.commit;
	
	    commit(types.SET_LOCALE, locale);
	    _helpers.i18n.locale(locale);
	  }
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.SET_LOCALE, function (state, locale) {
	  state.i18n.current = _helpers.i18n.localeItem(locale);
	});
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  nav: [{
	    label: 'Register',
	    name: 'register'
	  }, {
	    label: 'About',
	    name: 'about'
	  }, {
	    label: 'Table',
	    name: 'table'
	  }, {
	    label: 'Posts',
	    name: 'posts'
	  }]
	};
	
	var getters = {
	  getNav: function getNav(state) {
	    return state.nav;
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters
	};

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  name: null,
	  email: null
	};
	
	var getters = {
	  getNewsletter: function getNewsletter(state) {
	    return {
	      name: state.name,
	      email: state.email
	    };
	  }
	};
	
	var actions = {
	  sendNewsletter: function sendNewsletter(_ref, _ref2) {
	    var commit = _ref.commit;
	    var name = _ref2.name,
	        email = _ref2.email;
	
	    commit(types.SEND_NEWSLETTER, { name: name, email: email });
	  }
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.SEND_NEWSLETTER, function (state, _ref3) {
	  var name = _ref3.name,
	      email = _ref3.email;
	
	  state.name = name;
	  state.email = email;
	});
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  notification: {
	    message: null,
	    type: null
	  }
	};
	
	var getters = {
	  getNotification: function getNotification(state) {
	    return {
	      message: state.notification.message,
	      type: state.notification.type
	    };
	  }
	};
	
	var actions = {
	  notify: function notify(_ref, notification) {
	    var commit = _ref.commit;
	
	    commit(types.NOTIFY, notification);
	  }
	};
	
	var mutations = (0, _defineProperty3.default)({}, types.NOTIFY, function (state, notification) {
	  (0, _assign2.default)(state.notification, notification);
	});
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  posts: [],
	  paging: {},
	  post: {},
	  fields: [{
	    label: 'ID',
	    field: 'id'
	  }, {
	    label: 'Título',
	    field: 'title'
	  }, {
	    label: 'Data de publicação',
	    field: 'created_at'
	  }],
	  page: 1
	};
	
	var getters = {
	  getPosts: function getPosts(state) {
	    return state.posts;
	  },
	  getPost: function getPost(state) {
	    return state.post;
	  },
	  getPostFields: function getPostFields(state) {
	    return state.fields;
	  },
	  getPostConverters: function getPostConverters(state) {
	    return state.converters;
	  },
	  getPostPage: function getPostPage(state) {
	    return state.page;
	  },
	  getPostPaging: function getPostPaging(state) {
	    return state.paging;
	  }
	};
	
	var actions = {
	  getPosts: function getPosts(_ref) {
	    var commit = _ref.commit;
	    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    commit(types.CLEAN_POSTS);
	    return _vue2.default.http.get('posts', { params: { page: page } }).then(function (response) {
	      if (response.body.success) {
	        commit(types.SET_POSTS, response.body);
	        return response.body;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  },
	  getPost: function getPost(_ref2, id) {
	    var commit = _ref2.commit;
	
	    commit(types.CLEAN_POST);
	    return _vue2.default.http.get('posts/' + id).then(function (response) {
	      if (response.body.success) {
	        commit(types.SET_POST, response.body.data);
	        return response.body;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  },
	  createPost: function createPost(_ref3, post) {
	    var commit = _ref3.commit;
	
	    return _vue2.default.http.post('posts', post).then(function (response) {
	      if (response.body.success) {
	        commit(types.CREATED_POST, response.body.data);
	        return response.body;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  },
	  updatePost: function updatePost(_ref4, id, post) {
	    var commit = _ref4.commit;
	
	    return _vue2.default.http.post('posts/' + id + '/update', post).then(function (response) {
	      if (response.body.success) {
	        commit(types.UPDATED_POST, response.body.data);
	        return response.body;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  },
	  deletePost: function deletePost(_ref5, id) {
	    var commit = _ref5.commit;
	
	    return _vue2.default.http.delete('posts/' + id).then(function (response) {
	      if (response.body.success) {
	        return response.body;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  },
	  deletePosts: function deletePosts(_ref6, posts) {
	    var commit = _ref6.commit;
	
	    return _vue2.default.http.post('posts/bulk-delete', { posts: posts }).then(function (response) {
	      if (response.body.success) {
	        return response.body;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_POSTS, function (state, response) {
	  state.posts = response.data;
	  state.paging = response.paging;
	}), (0, _defineProperty3.default)(_mutations, types.SET_POST, function (state, post) {
	  state.post = post;
	}), (0, _defineProperty3.default)(_mutations, types.CREATED_POST, function (state, post) {
	  state.post = post;
	}), (0, _defineProperty3.default)(_mutations, types.UPDATED_POST, function (state, post) {
	  state.post = post;
	}), (0, _defineProperty3.default)(_mutations, types.CLEAN_POST, function (state) {
	  state.post = {};
	}), (0, _defineProperty3.default)(_mutations, types.CLEAN_POSTS, function (state) {
	  state.posts = [];
	}), (0, _defineProperty3.default)(_mutations, types.POST_PAGINATE, function (state, page) {
	  state.page = page;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  transitionName: 'scale-out',
	  transitionMode: 'out-in',
	  transitionNames: ['fade-left', 'fade-right', 'scale-out', 'scale-in']
	};
	
	var getters = {
	  getTransitionName: function getTransitionName(state) {
	    return state.transitionName;
	  },
	  getTransitionNames: function getTransitionNames(state) {
	    return state.transitionNames;
	  },
	  getTransitionMode: function getTransitionMode(state) {
	    return state.transitionMode;
	  }
	};
	
	var actions = {
	  setTransitionName: function setTransitionName(_ref, transitionName) {
	    var commit = _ref.commit;
	
	    commit(types.TRANSITION_NAME, transitionName);
	  },
	  setTransitionMode: function setTransitionMode(_ref2, transitionMode) {
	    var commit = _ref2.commit;
	
	    commit(types.TRANSITION_MODE, transitionMode);
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.TRANSITION_NAME, function (state, transitionName) {
	  state.transitionName = transitionName;
	}), (0, _defineProperty3.default)(_mutations, types.TRANSITION_MODE, function (state, transitionMode) {
	  state.transitionMode = transitionMode;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(12);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(5);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  ready: false,
	  user: {
	    id: null,
	    username: null,
	    password: null,
	    token: null
	  }
	};
	
	var getters = {
	  getUser: function getUser(state) {
	    return state.user;
	  },
	  getUserReady: function getUserReady(state) {
	    return state.ready;
	  },
	  loggedIn: function loggedIn(state) {
	    return !!state.user.id;
	  }
	};
	
	var actions = {
	  auth: function auth(_ref, data) {
	    var commit = _ref.commit;
	
	    return _vue2.default.http.post('auth/login', data).then(function (response) {
	      if (response.body.success) {
	        var user = response.body.data;
	        commit(types.LOGIN, user);
	        return user;
	      } else {
	        throw new Error(response.body.message);
	      }
	    });
	  },
	  checkLogin: function checkLogin(_ref2) {
	    var commit = _ref2.commit;
	
	    var token = _vue2.default.cookie.get('token');
	    if (token) {
	      var body = { token: token };
	      _vue2.default.http.post('auth/token', body).then(function (response) {
	        if (response.body.success) {
	          var user = response.body.data;
	          commit(types.SUCCESS_TOKEN, user);
	          return user;
	        } else {
	          commit(types.INVALID_TOKEN);
	        }
	      }).catch(function () {
	        commit(types.INVALID_TOKEN);
	      });
	    } else {
	      commit(types.INVALID_TOKEN);
	    }
	  },
	  logout: function logout(_ref3) {
	    var commit = _ref3.commit;
	
	    _vue2.default.cookie.delete('token');
	    commit(types.LOGOUT);
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.LOGIN, function (state, user) {
	  (0, _assign2.default)(state.user, user);
	}), (0, _defineProperty3.default)(_mutations, types.SUCCESS_TOKEN, function (state, user) {
	  (0, _assign2.default)(state.user, user);
	  state.ready = true;
	}), (0, _defineProperty3.default)(_mutations, types.INVALID_TOKEN, function (state, user) {
	  state.ready = true;
	}), (0, _defineProperty3.default)(_mutations, types.LOGOUT, function (state) {
	  state.user = {
	    id: null,
	    username: null,
	    password: null,
	    token: null
	  };
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _Ui = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    UiLayout: _Ui.UiLayout,
	    UiHeader: _Ui.UiHeader,
	    UiNav: _Ui.UiNav,
	    UiContent: _Ui.UiContent,
	    UiDialog: _Ui.UiDialog
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    loggedIn: 'loggedIn',
	    ready: 'getUserReady',
	    transitionName: 'getTransitionName',
	    transitionMode: 'getTransitionMode'
	  })),
	  mounted: function mounted() {
	    var _this = this;
	
	    if (!this.loggedIn) {
	      this.checkLogin();
	    }
	    this.$bus.$on('openDialog', function (config) {
	      _this.$refs.mainDialog.open(config);
	    });
	  },
	  updated: function updated() {
	    this.$refreshDocumentTitle();
	    this.$upgradeDom();
	  },
	
	  methods: {
	    isLoginRoute: function isLoginRoute() {
	      return this.$route.name === 'login';
	    },
	    checkLogin: function checkLogin() {
	      this.$store.dispatch('checkLogin');
	    }
	  }
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _PostForm = __webpack_require__(22);
	
	var _PostForm2 = _interopRequireDefault(_PostForm);
	
	var _UiSpinner = __webpack_require__(14);
	
	var _UiSpinner2 = _interopRequireDefault(_UiSpinner);
	
	var _converter = __webpack_require__(11);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'edit-post',
	  title: 'Edit Post',
	  components: { PostForm: _PostForm2.default, UiSpinner: _UiSpinner2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    post: 'getPost'
	  }), {
	    loadedPost: function loadedPost() {
	      return this.post.id;
	    }
	  }),
	  data: function data() {
	    return {
	      converter: _converter2.default
	    };
	  },
	  created: function created() {
	    if (this.$route.params.id) {
	      this.$store.dispatch('getPost', this.$route.params.id);
	    }
	  }
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PostForm = __webpack_require__(22);
	
	var _PostForm2 = _interopRequireDefault(_PostForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'new-post',
	  title: 'New Post',
	  breadcrumb: 'New',
	  components: { PostForm: _PostForm2.default }
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _Ui = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Posts',
	  name: 'post',
	  components: { UiModuleHeader: _Ui.UiModuleHeader },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    transitionName: 'getTransitionName',
	    transitionMode: 'getTransitionMode'
	  }))
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _marked = __webpack_require__(231);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _Ui = __webpack_require__(9);
	
	var _helpers = __webpack_require__(15);
	
	var _converter = __webpack_require__(11);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'post-form',
	  components: { UiFieldGroup: _Ui.UiFieldGroup, UiLabel: _Ui.UiLabel, UiText: _Ui.UiText, UiTextArea: _Ui.UiTextArea, UiButton: _Ui.UiButton },
	  props: {
	    record: Object,
	    type: { type: String, default: 'create' },
	    converter: Function
	  },
	  data: function data() {
	    return {
	      title: null,
	      created_at: (0, _moment2.default)().format('DD/MM/YYYY'),
	      body: null,
	      sending: false
	    };
	  },
	
	  computed: {
	    compiledMarkdown: function compiledMarkdown() {
	      if (this.body) {
	        return (0, _marked2.default)(this.body, { sanitize: true });
	      }
	    }
	  },
	  methods: {
	    sendForm: function sendForm() {
	      var _this = this;
	
	      if (this.isValid()) {
	        this.sending = true;
	        this.storeDispatch().then(function (result) {
	          if (result.success) {
	            _helpers.toast.show(result.message);
	            _this.$router.push({ name: 'posts' });
	          } else {
	            _helpers.toast.show(result.message, 'error');
	          }
	        });
	      } else {
	        this.sending = false;
	      }
	    },
	    isValid: function isValid() {
	      return true;
	    },
	    storeDispatch: function storeDispatch() {
	      if (this.type === 'create') {
	        return this.$store.dispatch('createPost', this.getSendData());
	      }
	      return this.$store.dispatch('updatePost', this.record.id, this.getSendData());
	    },
	    getSendData: function getSendData() {
	      return {
	        title: this.title,
	        created_at: this.created_at,
	        body: this.body
	      };
	    }
	  },
	  created: function created() {
	    if (this.record) {
	      for (var i in this.record) {
	        this[i] = (0, _converter2.default)(i, this.record[i]);
	      }
	    }
	  }
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _Ui = __webpack_require__(9);
	
	var _converter = __webpack_require__(11);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'post',
	  title: 'Posts',
	  components: { UiGrid: _Ui.UiGrid, UiButton: _Ui.UiButton, UiFloatingBox: _Ui.UiFloatingBox },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    posts: 'getPosts',
	    fields: 'getPostFields',
	    postPage: 'getPostPage',
	    postPaging: 'getPostPaging'
	  }), {
	    actions: function actions() {
	      var self = this;
	      return [{
	        icon: 'create',
	        primary: true,
	        handleClick: function handleClick(row) {
	          self.$router.push({ name: 'edit-post', params: { id: row.id } });
	        }
	      }, {
	        icon: 'delete',
	        danger: true,
	        handleClick: function handleClick(row) {
	          self.$bus.$emit('openDialog', {
	            text: '<p>Essa a\xE7\xE3o \xE9 irrevers\xEDvel. Quer continuar?</p><p>Item a ser exclu\xEDdo: <strong>' + row.title + '</strong></p>',
	            onAccept: function onAccept(closeDialog) {
	              self.$store.dispatch('deletePost', row.id).then(function (result) {
	                if (result.success) {
	                  self.loadPosts(self.page);
	                }
	                closeDialog();
	              });
	            }
	          });
	        }
	      }];
	    }
	  }),
	  data: function data() {
	    return {
	      page: 1,
	      converter: _converter2.default
	    };
	  },
	  created: function created() {
	    this.loadPosts();
	  },
	  updated: function updated() {
	    if (this.page !== this.postPage) {
	      this.page = this.postPage;
	      this.loadPosts(this.page);
	    }
	  },
	
	  methods: {
	    loadPosts: function loadPosts() {
	      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	      this.$store.dispatch('getPosts', page);
	    },
	    removeSelecteds: function removeSelecteds(selecteds) {
	      var _this = this;
	
	      var items = [];
	      for (var i in this.posts) {
	        var post = this.posts[i];
	        if (selecteds.indexOf(parseInt(post.id)) > -1) {
	          items.push('<li>' + post.title + '</li>');
	        }
	      }
	      this.$bus.$emit('openDialog', {
	        text: '<p>Essa a\xE7\xE3o \xE9 irrevers\xEDvel. Quer continuar?</p><p>Item(s) a ser(em) exclu\xEDdo(s):</p><ul>' + items.join('') + '</ul>',
	        onAccept: function onAccept(closeDialog) {
	          _this.$store.dispatch('deletePosts', selecteds).then(function (result) {
	            if (result.success) {
	              _this.loadPosts(_this.page);
	            }
	            closeDialog();
	          });
	        }
	      });
	    }
	  }
	};

/***/ },
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'about',
	  title: 'About'
	};

/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'home',
	  title: 'Dashboard'
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _toast = __webpack_require__(16);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _error_handler = __webpack_require__(25);
	
	var _error_handler2 = _interopRequireDefault(_error_handler);
	
	var _UiButton = __webpack_require__(13);
	
	var _UiButton2 = _interopRequireDefault(_UiButton);
	
	var _UiText = __webpack_require__(145);
	
	var _UiText2 = _interopRequireDefault(_UiText);
	
	var _UiLabel = __webpack_require__(144);
	
	var _UiLabel2 = _interopRequireDefault(_UiLabel);
	
	var _UiFieldGroup = __webpack_require__(142);
	
	var _UiFieldGroup2 = _interopRequireDefault(_UiFieldGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'login',
	  title: 'Login',
	  components: { UiButton: _UiButton2.default, UiText: _UiText2.default, UiLabel: _UiLabel2.default, UiFieldGroup: _UiFieldGroup2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    user: 'getUser',
	    loggedIn: 'loggedIn',
	    currentLocale: 'getCurrentLocale',
	    locales: 'getLocales'
	  })),
	  methods: {
	    sendForm: function sendForm(e) {
	      var _this = this;
	
	      this.disabled = true;
	      this.$store.dispatch('auth', {
	        username: this.username,
	        password: this.password
	      }).then(function (user) {
	        _toast2.default.show('Bem vindo ' + user.username + '!', 'success');
	        _this.$cookie.set('token', user.token);
	        _this.disabled = false;
	      }).catch(function (error) {
	        _this.disabled = false;
	        (0, _error_handler2.default)(error);
	      });
	    },
	    setLocale: function setLocale(locale) {
	      this.$store.dispatch('setLocale', locale);
	    },
	    checkLogged: function checkLogged() {
	      this.ready = false;
	      if (this.loggedIn) {
	        this.redirectLoggedUser();
	      } else {
	        this.ready = true;
	      }
	    },
	    redirectLoggedUser: function redirectLoggedUser() {
	      var params = null;
	      if (this.$route.query.params) {
	        try {
	          params = JSON.parse(this.$route.query.params);
	        } catch (error) {
	          params = null;
	        }
	      }
	      this.$router.push({
	        name: this.$route.query.redirect || 'home',
	        params: params
	      });
	    }
	  },
	  data: function data() {
	    return {
	      ready: false,
	      username: null,
	      password: null,
	      username_error: false,
	      password_error: false,
	      disabled: false
	    };
	  },
	  mounted: function mounted() {
	    this.checkLogged();
	  },
	  updated: function updated() {
	    if (this.loggedIn) {
	      this.redirectLoggedUser();
	    }
	  }
	};

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'not-found',
	  title: 'Not-found'
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _helpers = __webpack_require__(15);
	
	var _Ui = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'register',
	  title: 'Register',
	  components: { UiButton: _Ui.UiButton, UiText: _Ui.UiText, UiLabel: _Ui.UiLabel, UiFieldGroup: _Ui.UiFieldGroup, UiIcon: _Ui.UiIcon },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    newsletter: 'getNewsletter'
	  })),
	  methods: {
	    sendForm: function sendForm(e) {
	      var _this = this;
	
	      if (this.name) {
	        var messages = ['Obrigado! <strong>' + this.name + '</strong>', 'Voc\xEA \xE9 demais <strong>' + this.name + '</strong>!', '<strong>' + this.name + '</strong>, agrademos muito', '<strong>' + this.name + '</strong> at\xE9 breve!'];
	        var random = Math.floor(Math.random() * messages.length);
	        var message = messages[random];
	
	        this.name_error = false;
	        this.disabled = true;
	        this.success = true;
	        this.message = message;
	        _helpers.toast.show(this.message, 'success');
	        this.sendNewsletter(this.name, this.email);
	
	        setTimeout(function () {
	          _this.disabled = false;
	        }, 2000);
	      } else {
	        _helpers.toast.show('Por favor, digite os dados completos', 'error');
	        this.name_error = true;
	      }
	    },
	    notificate: function notificate(e) {
	      _helpers.toast.show('Hello world!');
	    },
	    sendNewsletter: function sendNewsletter(name, email) {
	      this.$store.dispatch('sendNewsletter', { name: name, email: email });
	    },
	    cleanForm: function cleanForm() {
	      this.success = false;
	    }
	  },
	  data: function data() {
	    return {
	      name: null,
	      email: null,
	      name_error: false,
	      email_error: false,
	      disabled: false,
	      success: false,
	      message: null
	    };
	  }
	};

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'table',
	  title: 'Table'
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Mixins = __webpack_require__(3);
	
	var _UiSpinner = __webpack_require__(14);
	
	var _UiSpinner2 = _interopRequireDefault(_UiSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ui-button',
	  mixins: [_Mixins.uiComponent],
	  components: { UiSpinner: _UiSpinner2.default },
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-button': true,
	        'mdl-button--icon': this.icon && !this.bigIcon,
	        'mdl-button--accent': this.accent,
	        'mdl-button--primary': this.primary,
	        'mdl-button--mini-fab': this.miniFab,
	        'mdl-button--fab': this.fab || this.miniFab,
	        'mdl-button--raised': this.raised,
	        'mdl-button--colored': this.colored,
	        'mdl-js-button': this.js,
	        'mdl-js-ripple-effect': this.ripple,
	        'button-with-spinner': this.spinner
	      };
	    },
	    isIconSpecified: function isIconSpecified() {
	      return this.icon && typeof this.icon === 'string';
	    },
	    isWithIconSpecified: function isWithIconSpecified() {
	      return this.withIcon;
	    }
	  },
	  props: {
	    type: { type: String, default: 'submit' },
	    disabled: Boolean,
	    icon: [String, Boolean],
	    bigIcon: Boolean,
	    withIcon: String,
	    accent: Boolean,
	    primary: Boolean,
	    miniFab: Boolean,
	    fab: Boolean,
	    raised: Boolean,
	    colored: Boolean,
	    js: { type: Boolean, default: true },
	    ripple: { type: Boolean, default: true },
	    spinner: { type: Boolean, default: false }
	  }
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Mixins = __webpack_require__(3);
	
	exports.default = {
	  name: 'ui-checkbox',
	  mixins: [_Mixins.uiComponent],
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-checkbox__input': true
	      };
	    }
	  },
	  props: {
	    id: String,
	    name: String,
	    value: String,
	    checked: { type: Boolean, default: false },
	    label: String
	  },
	  created: function created() {
	    this.updateValue(this.value);
	  },
	
	  methods: {
	    updateValue: function updateValue(value) {
	      this.$emit('input', value);
	    },
	    check: function check() {
	      this.$el.MaterialCheckbox.check();
	    },
	    uncheck: function uncheck() {
	      this.$el.MaterialCheckbox.uncheck();
	    },
	    isChecked: function isChecked() {
	      return this.$el.querySelector('input[type=checkbox]').checked;
	    }
	  }
	};

/***/ },
/* 177 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'main-content'
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dialogPolyfill = __webpack_require__(224);
	
	var _dialogPolyfill2 = _interopRequireDefault(_dialogPolyfill);
	
	var _UiButton = __webpack_require__(13);
	
	var _UiButton2 = _interopRequireDefault(_UiButton);
	
	var _Mixins = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ui-dialog',
	  mixins: [_Mixins.uiComponent],
	  components: { UiButton: _UiButton2.default },
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-button': true
	      };
	    }
	  },
	  data: function data() {
	    return {
	      title: 'Confirmação',
	      text: null,
	      dialog: null,
	      onAccept: null,
	      acceptText: 'Sim',
	      cancelText: 'Cancelar',
	      disabledAccept: false
	    };
	  },
	  mounted: function mounted() {
	    this.dialog = document.querySelector('dialog');
	    if (!this.dialog.showModal) {
	      _dialogPolyfill2.default.registerDialog(this.dialog);
	    }
	  },
	
	  methods: {
	    open: function open(config) {
	      this.reset();
	      this.setConfig(config);
	      this.dialog.showModal();
	    },
	    close: function close() {
	      this.dialog.close();
	    },
	    setConfig: function setConfig(config) {
	      for (var i in config) {
	        this[i] = config[i];
	      }
	    },
	    accept: function accept() {
	      this.disabledAccept = true;
	      if (typeof this.onAccept === 'function') {
	        this.onAccept(this.close);
	      }
	    },
	    reset: function reset() {
	      this.disabledAccept = false;
	    }
	  }
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Mixins = __webpack_require__(3);
	
	exports.default = {
	  name: 'ui-field-group',
	  mixins: [_Mixins.uiComponent],
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-textfield': this.simple,
	        'mdl-js-textfield': this.js,
	        'mdl-textfield--floating-label': this.floating,
	        'mdl-textfield-full': this.full,
	        'is-invalid': this.invalid,
	        'is-dirty': !this.invalid && this.value !== null
	      };
	    }
	  },
	  props: {
	    simple: { type: Boolean, default: true },
	    js: { type: Boolean, default: true },
	    floating: { type: Boolean, default: true },
	    full: { type: Boolean, default: true },
	    invalid: Boolean,
	    value: String,
	    help: String
	  }
	};

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ui-floating-box',
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'floating-button': true,
	        'hidden-on-transition': this.hiddenOnTransition,
	        'right': this.right,
	        'left': this.left
	      };
	    }
	  },
	  props: {
	    hiddenOnTransition: { type: Boolean, default: true },
	    right: { type: Boolean, default: true },
	    left: { type: Boolean, default: false }
	  }
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UiButton = __webpack_require__(13);
	
	var _UiButton2 = _interopRequireDefault(_UiButton);
	
	var _UiSpinner = __webpack_require__(14);
	
	var _UiSpinner2 = _interopRequireDefault(_UiSpinner);
	
	var _UiGridRow = __webpack_require__(143);
	
	var _UiGridRow2 = _interopRequireDefault(_UiGridRow);
	
	var _UiCheckbox = __webpack_require__(141);
	
	var _UiCheckbox2 = _interopRequireDefault(_UiCheckbox);
	
	var _Mixins = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ui-grid',
	  mixins: [_Mixins.uiComponent],
	  components: { UiButton: _UiButton2.default, UiSpinner: _UiSpinner2.default, UiGridRow: _UiGridRow2.default, UiCheckbox: _UiCheckbox2.default },
	  props: {
	    name: { type: String, required: true },
	    records: { type: Array, required: true },
	    fields: { type: Array, required: true },
	    actions: { type: Array },
	    selectable: { type: Boolean, default: true },
	    shadow: { type: Boolean, default: true },
	    dataTable: { type: Boolean, default: true },
	    fluid: { type: Boolean, default: true },
	    breakWord: { type: Boolean, default: true },
	    converter: Function,
	    selectedsLabel: { type: String, default: 'Remover selecionados' },
	    paging: { type: Object, default: {} },
	    chunk: { type: Number, default: 10 }
	  },
	  computed: {
	    tableCssClasses: function tableCssClasses() {
	      return {
	        'mdl-data-table': this.dataTable,
	        'mdl-js-data-table': this.dataTable,
	        'mdl-shadow--2dp': this.shadow,
	        'table-fluid': this.fluid,
	        'table-break-word': this.breakWord
	      };
	    },
	    hasRowSelected: function hasRowSelected() {
	      return this.selecteds.length > 0;
	    }
	  },
	  data: function data() {
	    return {
	      selecteds: []
	    };
	  },
	
	  methods: {
	    getThClass: function getThClass(item) {
	      return this.thClass({
	        string: item.type === 'string' || !item.type,
	        asc: item.sort === 'asc',
	        desc: item.sort === 'desc'
	      });
	    },
	    getTdClass: function getTdClass() {
	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return this.tdClass({
	        string: item.type === 'string' || !item.type
	      });
	    },
	    tdClass: function tdClass(item) {
	      return {
	        'mdl-data-table__cell--non-numeric': item.string
	      };
	    },
	    thClass: function thClass(item) {
	      return {
	        'mdl-data-table__cell--non-numeric': item.string,
	        'mdl-data-table__header--sorted-ascending': item.asc,
	        'mdl-data-table__header--sorted-descending': item.desc
	      };
	    },
	    itemsRow: function itemsRow(row) {
	      var output = {};
	      for (var i in this.fields) {
	        var item = this.fields[i];
	        output[item.field] = row[item.field];
	      }
	      return output;
	    },
	    hasRecords: function hasRecords() {
	      return this.records.length > 0;
	    },
	    getRowValue: function getRowValue(field, value) {
	      if (this.converter) {
	        return this.converter(field, value);
	      }
	      return value;
	    },
	    removeSelecteds: function removeSelecteds() {
	      this.$emit('selectedsAction', this.selecteds);
	    },
	    selectAll: function selectAll(e) {
	      if (e.target.checked) {
	        this.selecteds = this.$refs.row.map(function (item) {
	          for (var i in item.$children) {
	            var child = item.$children[i];
	            if (child.name === 'checkbox-item') {
	              child.check();
	            }
	          }
	          return parseInt(item.$el.dataset.id);
	        });
	      } else {
	        this.selecteds = [];
	        this.$refs.row.map(function (item) {
	          for (var i in item.$children) {
	            var child = item.$children[i];
	            if (child.name === 'checkbox-item') {
	              child.uncheck();
	            }
	          }
	        });
	      }
	    },
	    updateSelecteds: function updateSelecteds(e) {
	      this.selecteds = this.$refs.row.filter(function (item) {
	        var checked = false;
	        for (var i in item.$children) {
	          var child = item.$children[i];
	          if (child.name === 'checkbox-item') {
	            checked = child.isChecked();
	          }
	        }
	        return checked;
	      }).map(function (item) {
	        return parseInt(item.$el.dataset.id);
	      });
	    }
	  },
	  updated: function updated() {
	    this.$upgradeDom();
	  }
	};

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ui-grid-row',
	  data: function data() {
	    return {
	      selected: false
	    };
	  },
	
	  props: {
	    selectable: false
	  },
	  computed: {
	    selectedRowClass: function selectedRowClass() {
	      return {
	        'is-selected': this.selected
	      };
	    }
	  },
	  methods: {
	    selectRow: function selectRow() {
	      if (this.selectable) {
	        this.selected = !this.selected;
	        this.$emit('selectRow');
	      }
	    },
	    isSelected: function isSelected() {
	      return this.selected;
	    }
	  }
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _UiIcon = __webpack_require__(23);
	
	var _UiIcon2 = _interopRequireDefault(_UiIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'main-header',
	  components: {
	    UiIcon: _UiIcon2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    loggedIn: 'loggedIn',
	    user: 'getUser',
	    currentLocale: 'getCurrentLocale',
	    locales: 'getLocales',
	    transitionName: 'getTransitionName',
	    transitionNames: 'getTransitionNames',
	    nav: 'getNav'
	  })),
	  methods: {
	    setLocale: function setLocale(locale) {
	      this.$store.dispatch('setLocale', locale);
	    },
	    setTransitionName: function setTransitionName(name) {
	      this.$store.dispatch('setTransitionName', name);
	    }
	  }
	};

/***/ },
/* 184 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ui-icon',
	  computed: {
	    cssClasses: function cssClasses() {
	      var options = {
	        'material-icons': true,
	        'rounded-icon': this.rounded
	      };
	      if (this.size) options['icon-' + this.size] = true;
	      return options;
	    }
	  },
	  props: {
	    rounded: Boolean,
	    size: String,
	    name: { type: String, required: true }
	  }
	};

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ui-label',
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-textfield__label': this.simple
	      };
	    }
	  },
	  props: {
	    id: String,
	    name: String,
	    value: String,
	    simple: { type: Boolean, default: true }
	  }
	};

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'main-layout'
	};

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ui-module-header',
	  props: {
	    title: { type: String, required: true },
	    icon: { type: String, required: true }
	  }
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'main-nav',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    user: 'getUser',
	    currentLocale: 'getCurrentLocale',
	    locales: 'getLocales',
	    nav: 'getNav'
	  })),
	  methods: {
	    hideNav: function hideNav(e) {
	      var event = new window.Event('click');
	      document.querySelector('.mdl-layout__drawer-button').dispatchEvent(event);
	    },
	    setLocale: function setLocale(locale) {
	      this.$store.dispatch('setLocale', locale);
	      this.hideNav();
	    }
	  }
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Mixins = __webpack_require__(3);
	
	exports.default = {
	  name: 'ui-spinner',
	  mixins: [_Mixins.uiComponent],
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-spinner ': true,
	        'mdl-js-spinner': true,
	        'is-active': true,
	        'mdl-spinner--single-color': this.singleColor
	      };
	    },
	    cssBoxClasses: function cssBoxClasses() {
	      return {
	        'spinner-box ': true,
	        'center ': this.center
	      };
	    }
	  },
	  props: {
	    center: { type: Boolean, default: false },
	    singleColor: { type: Boolean, default: false }
	  }
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Mixins = __webpack_require__(3);
	
	exports.default = {
	  name: 'ui-text',
	  mixins: [_Mixins.uiComponent],
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-textfield__input': this.simple
	      };
	    }
	  },
	  props: {
	    id: String,
	    name: String,
	    value: String,
	    simple: { type: Boolean, default: true }
	  },
	  created: function created() {
	    this.updateValue(this.value);
	  },
	
	  methods: {
	    updateValue: function updateValue(value) {
	      this.$emit('input', value);
	    }
	  }
	};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Mixins = __webpack_require__(3);
	
	exports.default = {
	  name: 'ui-text-area',
	  mixins: [_Mixins.uiComponent],
	  computed: {
	    cssClasses: function cssClasses() {
	      return {
	        'mdl-textfield__input': this.simple
	      };
	    },
	    styles: function styles() {
	      return {
	        resize: this.resize ? 'both' : 'none'
	      };
	    }
	  },
	  props: {
	    id: String,
	    name: String,
	    value: String,
	    simple: { type: Boolean, default: true },
	    rows: { type: Number, default: 5 },
	    resize: { type: Boolean, default: false }
	  },
	  created: function created() {
	    this.updateValue(this.value);
	  },
	
	  methods: {
	    updateValue: function updateValue(value) {
	      this.$emit('input', value);
	    }
	  }
	};

/***/ },
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 226 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 227 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = {
		"welcome": "Welcome <strong>%{name}</strong>",
		"actions": {
			"enter": "Enter"
		},
		"models": {
			"user": {
				"username": "Username",
				"password": "Password"
			}
		},
		"pages": {
			"login": {
				"title": "Login",
				"tip": "Tip <code>admin:123</code>"
			}
		},
		"modules": {
			"posts": {
				"new": "New post"
			}
		}
	};

/***/ },
/* 229 */
/***/ function(module, exports) {

	module.exports = {
		"welcome": "Bienvenido <strong>%{name}</strong>",
		"actions": {
			"enter": "Entrar"
		},
		"models": {
			"user": {
				"username": "Nombre de usuário",
				"password": "Contraseña"
			}
		},
		"pages": {
			"login": {
				"title": "Conecte",
				"tip": "Punta <code>admin:123</code>"
			}
		},
		"modules": {
			"posts": {
				"new": "Nuovo post"
			}
		}
	};

/***/ },
/* 230 */
/***/ function(module, exports) {

	module.exports = {
		"welcome": "Bem-vindo <strong>%{name}</strong>",
		"actions": {
			"enter": "Entrar",
			"save": "Salvar"
		},
		"models": {
			"user": {
				"username": "Nome de usuário",
				"password": "Senha"
			}
		},
		"pages": {
			"login": {
				"title": "Entrar",
				"tip": "Dica <code>admin:123</code>"
			}
		},
		"modules": {
			"posts": {
				"new": "Nova postagem",
				"edit": "Editar postagem",
				"fields": {
					"created_at": "Data de publicação",
					"title": "Título",
					"body": "Texto"
				},
				"help": {
					"created_at": "Digite a data de publicação",
					"title": "Digite um título",
					"body": "Digite o texto"
				}
			}
		}
	};

/***/ },
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 33,
		"./af.js": 33,
		"./ar": 39,
		"./ar-dz": 34,
		"./ar-dz.js": 34,
		"./ar-ly": 35,
		"./ar-ly.js": 35,
		"./ar-ma": 36,
		"./ar-ma.js": 36,
		"./ar-sa": 37,
		"./ar-sa.js": 37,
		"./ar-tn": 38,
		"./ar-tn.js": 38,
		"./ar.js": 39,
		"./az": 40,
		"./az.js": 40,
		"./be": 41,
		"./be.js": 41,
		"./bg": 42,
		"./bg.js": 42,
		"./bn": 43,
		"./bn.js": 43,
		"./bo": 44,
		"./bo.js": 44,
		"./br": 45,
		"./br.js": 45,
		"./bs": 46,
		"./bs.js": 46,
		"./ca": 47,
		"./ca.js": 47,
		"./cs": 48,
		"./cs.js": 48,
		"./cv": 49,
		"./cv.js": 49,
		"./cy": 50,
		"./cy.js": 50,
		"./da": 51,
		"./da.js": 51,
		"./de": 53,
		"./de-at": 52,
		"./de-at.js": 52,
		"./de.js": 53,
		"./dv": 54,
		"./dv.js": 54,
		"./el": 55,
		"./el.js": 55,
		"./en-au": 56,
		"./en-au.js": 56,
		"./en-ca": 57,
		"./en-ca.js": 57,
		"./en-gb": 58,
		"./en-gb.js": 58,
		"./en-ie": 59,
		"./en-ie.js": 59,
		"./en-nz": 60,
		"./en-nz.js": 60,
		"./eo": 61,
		"./eo.js": 61,
		"./es": 63,
		"./es-do": 62,
		"./es-do.js": 62,
		"./es.js": 63,
		"./et": 64,
		"./et.js": 64,
		"./eu": 65,
		"./eu.js": 65,
		"./fa": 66,
		"./fa.js": 66,
		"./fi": 67,
		"./fi.js": 67,
		"./fo": 68,
		"./fo.js": 68,
		"./fr": 71,
		"./fr-ca": 69,
		"./fr-ca.js": 69,
		"./fr-ch": 70,
		"./fr-ch.js": 70,
		"./fr.js": 71,
		"./fy": 72,
		"./fy.js": 72,
		"./gd": 73,
		"./gd.js": 73,
		"./gl": 74,
		"./gl.js": 74,
		"./he": 75,
		"./he.js": 75,
		"./hi": 76,
		"./hi.js": 76,
		"./hr": 77,
		"./hr.js": 77,
		"./hu": 78,
		"./hu.js": 78,
		"./hy-am": 79,
		"./hy-am.js": 79,
		"./id": 80,
		"./id.js": 80,
		"./is": 81,
		"./is.js": 81,
		"./it": 82,
		"./it.js": 82,
		"./ja": 83,
		"./ja.js": 83,
		"./jv": 84,
		"./jv.js": 84,
		"./ka": 85,
		"./ka.js": 85,
		"./kk": 86,
		"./kk.js": 86,
		"./km": 87,
		"./km.js": 87,
		"./ko": 88,
		"./ko.js": 88,
		"./ky": 89,
		"./ky.js": 89,
		"./lb": 90,
		"./lb.js": 90,
		"./lo": 91,
		"./lo.js": 91,
		"./lt": 92,
		"./lt.js": 92,
		"./lv": 93,
		"./lv.js": 93,
		"./me": 94,
		"./me.js": 94,
		"./mi": 95,
		"./mi.js": 95,
		"./mk": 96,
		"./mk.js": 96,
		"./ml": 97,
		"./ml.js": 97,
		"./mr": 98,
		"./mr.js": 98,
		"./ms": 100,
		"./ms-my": 99,
		"./ms-my.js": 99,
		"./ms.js": 100,
		"./my": 101,
		"./my.js": 101,
		"./nb": 102,
		"./nb.js": 102,
		"./ne": 103,
		"./ne.js": 103,
		"./nl": 105,
		"./nl-be": 104,
		"./nl-be.js": 104,
		"./nl.js": 105,
		"./nn": 106,
		"./nn.js": 106,
		"./pa-in": 107,
		"./pa-in.js": 107,
		"./pl": 108,
		"./pl.js": 108,
		"./pt": 110,
		"./pt-br": 109,
		"./pt-br.js": 109,
		"./pt.js": 110,
		"./ro": 111,
		"./ro.js": 111,
		"./ru": 112,
		"./ru.js": 112,
		"./se": 113,
		"./se.js": 113,
		"./si": 114,
		"./si.js": 114,
		"./sk": 115,
		"./sk.js": 115,
		"./sl": 116,
		"./sl.js": 116,
		"./sq": 117,
		"./sq.js": 117,
		"./sr": 119,
		"./sr-cyrl": 118,
		"./sr-cyrl.js": 118,
		"./sr.js": 119,
		"./ss": 120,
		"./ss.js": 120,
		"./sv": 121,
		"./sv.js": 121,
		"./sw": 122,
		"./sw.js": 122,
		"./ta": 123,
		"./ta.js": 123,
		"./te": 124,
		"./te.js": 124,
		"./tet": 125,
		"./tet.js": 125,
		"./th": 126,
		"./th.js": 126,
		"./tl-ph": 127,
		"./tl-ph.js": 127,
		"./tlh": 128,
		"./tlh.js": 128,
		"./tr": 129,
		"./tr.js": 129,
		"./tzl": 130,
		"./tzl.js": 130,
		"./tzm": 132,
		"./tzm-latn": 131,
		"./tzm-latn.js": 131,
		"./tzm.js": 132,
		"./uk": 133,
		"./uk.js": 133,
		"./uz": 134,
		"./uz.js": 134,
		"./vi": 135,
		"./vi.js": 135,
		"./x-pseudo": 136,
		"./x-pseudo.js": 136,
		"./yo": 137,
		"./yo.js": 137,
		"./zh-cn": 138,
		"./zh-cn.js": 138,
		"./zh-hk": 139,
		"./zh-hk.js": 139,
		"./zh-tw": 140,
		"./zh-tw.js": 140
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 234;


/***/ },
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(225)
	
	/* script */
	__vue_exports__ = __webpack_require__(163)
	
	/* template */
	var __vue_template__ = __webpack_require__(274)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(164)
	
	/* template */
	var __vue_template__ = __webpack_require__(269)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(165)
	
	/* template */
	var __vue_template__ = __webpack_require__(278)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(166)
	
	/* template */
	var __vue_template__ = __webpack_require__(267)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(168)
	
	/* template */
	var __vue_template__ = __webpack_require__(271)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(169)
	
	/* template */
	var __vue_template__ = __webpack_require__(280)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(170)
	
	/* template */
	var __vue_template__ = __webpack_require__(279)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(227)
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(282)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a97f3b72"
	
	module.exports = __vue_exports__


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(172)
	
	/* template */
	var __vue_template__ = __webpack_require__(276)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(226)
	
	/* script */
	__vue_exports__ = __webpack_require__(173)
	
	/* template */
	var __vue_template__ = __webpack_require__(277)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77bdbd35"
	
	module.exports = __vue_exports__


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(174)
	
	/* template */
	var __vue_template__ = __webpack_require__(286)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(177)
	
	/* template */
	var __vue_template__ = __webpack_require__(270)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(178)
	
	/* template */
	var __vue_template__ = __webpack_require__(268)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(180)
	
	/* template */
	var __vue_template__ = __webpack_require__(275)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(181)
	
	/* template */
	var __vue_template__ = __webpack_require__(263)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(183)
	
	/* template */
	var __vue_template__ = __webpack_require__(258)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(186)
	
	/* template */
	var __vue_template__ = __webpack_require__(285)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(187)
	
	/* template */
	var __vue_template__ = __webpack_require__(273)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(188)
	
	/* template */
	var __vue_template__ = __webpack_require__(259)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(191)
	
	/* template */
	var __vue_template__ = __webpack_require__(264)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "mdl-layout__header mdl-layout__header--transparent"
	  }, [_c('div', {
	    staticClass: "mdl-layout__header-row"
	  }, [_c('span', {
	    staticClass: "mdl-layout-title"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Vue")])], 1), _vm._v(" "), (_vm.loggedIn) ? _c('span', {
	    staticClass: "welcome-user"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('welcome', {
	        name: _vm.user.username
	      }))
	    }
	  }), _vm._v(" ("), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'logout'
	      }
	    }
	  }, [_vm._v("sair")]), _vm._v(")\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mdl-layout-spacer"
	  }), _vm._v(" "), _c('nav', {
	    staticClass: "mdl-navigation mdl-cell--hide-phone"
	  }, _vm._l((_vm.nav), function(item) {
	    return _c('router-link', {
	      staticClass: "mdl-navigation__link",
	      attrs: {
	        "to": {
	          name: item.name
	        }
	      }
	    }, [_vm._v(_vm._s(item.label))])
	  })), _vm._v(" "), _c('a', {
	    staticClass: "mdl-navigation__link mdl-cell--hide-phone",
	    attrs: {
	      "id": "languages-menu",
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('ui-icon', {
	    attrs: {
	      "name": "language"
	    }
	  }), _vm._v("\n      " + _vm._s(_vm.currentLocale.name) + "\n    ")], 1), _vm._v(" "), _c('ul', {
	    staticClass: "mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect mdl-cell--hide-phone",
	    attrs: {
	      "for": "languages-menu"
	    }
	  }, _vm._l((_vm.locales), function(item) {
	    return (_vm.locales) ? _c('li', {
	      class: {
	        'mdl-menu__item': true, 'active': item.active
	      }
	    }, [_c('span', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.setLocale(item.locale)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(item.name))])]) : _vm._e()
	  })), _vm._v(" "), _c('a', {
	    staticClass: "mdl-navigation__link mdl-cell--hide-phone",
	    attrs: {
	      "id": "transition-names",
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('ui-icon', {
	    attrs: {
	      "name": "build"
	    }
	  }), _vm._v("\n      " + _vm._s(_vm.transitionName) + "\n    ")], 1), _vm._v(" "), _c('ul', {
	    staticClass: "mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect mdl-cell--hide-phone",
	    attrs: {
	      "for": "transition-names"
	    }
	  }, _vm._l((_vm.transitionNames), function(item) {
	    return (_vm.transitionNames) ? _c('li', {
	      class: {
	        'mdl-menu__item': true, 'active': item.active
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.setTransitionName(item)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")]) : _vm._e()
	  }))])])
	},staticRenderFns: []}

/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-layout__drawer"
	  }, [_c('span', {
	    staticClass: "mdl-layout-title"
	  }, [_vm._v("Vue")]), _vm._v(" "), _c('nav', {
	    staticClass: "mdl-navigation"
	  }, [_vm._l((_vm.nav), function(item) {
	    return _c('router-link', {
	      staticClass: "mdl-navigation__link",
	      attrs: {
	        "to": {
	          name: item.name
	        }
	      },
	      nativeOn: {
	        "click": function($event) {
	          _vm.hideNav($event)
	        }
	      }
	    }, [_vm._v(_vm._s(item.label))])
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.locales), function(item) {
	    return (_vm.locales) ? _c('a', {
	      class: {
	        'mdl-navigation__link': true, 'language-item-mobile': true, 'active': item.active
	      },
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.setLocale(item.locale)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]) : _vm._e()
	  })], 2), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-layout__drawer-button",
	    attrs: {
	      "aria-expanded": "false",
	      "role": "button",
	      "tabindex": "0"
	    }
	  }, [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("more_horiz")])])
	}]}

/***/ },
/* 260 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.cssBoxClasses
	  }, [_c('div', {
	    class: _vm.cssClasses
	  })])
	},staticRenderFns: []}

/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.cssClasses
	  }, [_vm._t("default"), _vm._v(" "), (_vm.help) ? _c('span', {
	    staticClass: "mdl-textfield__error"
	  }, [_vm._v(_vm._s(_vm.help))]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "post-form"
	  }, [_c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.sendForm($event)
	      }
	    }
	  }, [_c('ui-field-group', {
	    attrs: {
	      "help": _vm.$t('modules.posts.help.created_at')
	    }
	  }, [_c('ui-text', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.created_at),
	      expression: "created_at"
	    }],
	    attrs: {
	      "name": "created_at",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.created_at)
	    },
	    on: {
	      "input": function($event) {
	        _vm.created_at = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('modules.posts.fields.created_at')))])], 1), _vm._v(" "), _c('ui-field-group', {
	    attrs: {
	      "help": _vm.$t('modules.posts.help.title')
	    }
	  }, [_c('ui-text', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "name": "title",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        _vm.title = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('modules.posts.fields.title')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "mdl-grid"
	  }, [_c('div', {
	    staticClass: "mdl-cell mdl-cell--6-col"
	  }, [_c('ui-field-group', {
	    attrs: {
	      "help": _vm.$t('modules.posts.help.body')
	    }
	  }, [_c('ui-text-area', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.body),
	      expression: "body"
	    }],
	    attrs: {
	      "name": "body",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.body)
	    },
	    on: {
	      "input": function($event) {
	        _vm.body = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('modules.posts.fields.body')))])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--6-col"
	  }, [_c('small', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
	    staticClass: "markdown-preview",
	    domProps: {
	      "innerHTML": _vm._s(_vm.compiledMarkdown)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "submit-box"
	  }, [_c('ui-button', {
	    attrs: {
	      "disabled": _vm.sending,
	      "spinner": "",
	      "type": "submit",
	      "raised": "",
	      "primary": ""
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.save')) + "\n      ")])], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 263 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-responsive-table-box"
	  }, [(_vm.hasRecords()) ? _c('div', [_c('table', {
	    class: _vm.tableCssClasses
	  }, [_c('thead', [_c('tr', [(_vm.selectable) ? _c('th', [_c('ui-checkbox', {
	    nativeOn: {
	      "change": function($event) {
	        _vm.selectAll($event)
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.fields), function(item) {
	    return _c('th', {
	      class: _vm.getThClass(item)
	    }, [_vm._v(_vm._s(item.label))])
	  }), _vm._v(" "), (_vm.actions) ? _c('th') : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.records), function(row, index) {
	    return _c("ui-grid-row", {
	      ref: "row",
	      refInFor: true,
	      tag: "tr",
	      attrs: {
	        "data-id": row.id
	      }
	    }, [_c('td', [_c('ui-checkbox', {
	      attrs: {
	        "name": "checkbox-item"
	      },
	      nativeOn: {
	        "change": function($event) {
	          _vm.updateSelecteds($event)
	        }
	      }
	    })], 1), _vm._v(" "), _vm._l((_vm.itemsRow(row)), function(value, field) {
	      return _c('td', {
	        class: _vm.getTdClass()
	      }, [_vm._v(_vm._s(_vm.getRowValue(field, value)))])
	    }), _vm._v(" "), (_vm.actions) ? _c('td', {
	      staticClass: "td-actions"
	    }, _vm._l((_vm.actions), function(item) {
	      return _c('ui-button', {
	        attrs: {
	          "icon": item.icon,
	          "type": "button",
	          "primary": item.primary,
	          "raised": item.raised,
	          "fab": "",
	          "colored": ""
	        },
	        nativeOn: {
	          "click": function($event) {
	            item.handleClick(row)
	          }
	        }
	      })
	    })) : _vm._e()], 2)
	  }))]), _vm._v(" "), (_vm.selectable) ? _c('div', [_c('hr'), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "primary": "",
	      "raised": "",
	      "colored": "",
	      "disabled": !_vm.hasRowSelected
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.removeSelecteds($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.selectedsLabel))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.hasRecords()) ? _c('ui-spinner', {
	    attrs: {
	      "center": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.paging.pages) ? _c('pagination', {
	    attrs: {
	      "for": _vm.name,
	      "per-page": _vm.paging.limit,
	      "records": _vm.paging.total,
	      "chunk": 10,
	      "count-text": "Mostrando {from} a {to} de {count} registros|{count} registros|Um registro"
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 264 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('textarea', {
	    class: _vm.cssClasses,
	    style: (_vm.styles),
	    attrs: {
	      "id": _vm.id,
	      "name": _vm.name,
	      "rows": _vm.rows
	    },
	    domProps: {
	      "value": _vm.value
	    },
	    on: {
	      "input": function($event) {
	        _vm.updateValue($event.target.value)
	      }
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 265 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    class: _vm.selectedRowClass,
	    on: {
	      "click": _vm.selectRow
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 266 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
	  }, [_c('input', {
	    staticClass: "mdl-checkbox__input",
	    attrs: {
	      "type": "checkbox",
	      "name": _vm.name,
	      "id": _vm.id
	    },
	    domProps: {
	      "checked": _vm.checked,
	      "value": _vm.value
	    }
	  }), _vm._v(" "), (_vm.label) ? _c('span', {
	    staticClass: "mdl-checkbox__label"
	  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "posts"
	  }, [_c('ui-module-header', {
	    attrs: {
	      "title": "Posts",
	      "icon": "inbox"
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.transitionName,
	      "mode": _vm.transitionMode
	    },
	    on: {
	      "enter": _vm.$defaultEnterTransition
	    }
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('dialog', {
	    staticClass: "mdl-dialog"
	  }, [(_vm.title) ? _c('h4', {
	    staticClass: "mdl-dialog__title"
	  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
	    staticClass: "mdl-dialog__content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mdl-dialog__actions"
	  }, [(_vm.onAccept) ? _c('ui-button', {
	    attrs: {
	      "raised": "",
	      "primary": "",
	      "disabled": _vm.disabledAccept
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.accept($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.acceptText))]) : _vm._e(), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "disabled": _vm.disabledAccept
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.close($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText))])], 1)])
	},staticRenderFns: []}

/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "edit-post"
	  }, [_c('ui-second-title', [_vm._v(_vm._s(_vm.$t('modules.posts.edit')))]), _vm._v(" "), (_vm.loadedPost) ? _c('post-form', {
	    attrs: {
	      "record": _vm.post,
	      "converter": _vm.converter,
	      "type": "update"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.loadedPost) ? _c('ui-spinner', {
	    attrs: {
	      "center": ""
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "mdl-layout__content"
	  }, [_c('section', {
	    staticClass: "mdl-layout__tab-panel is-active",
	    attrs: {
	      "id": "scroll-tab-1"
	    }
	  }, [_c('div', {
	    staticClass: "page-content"
	  }, [_vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ },
/* 271 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "post-list"
	  }, [_c('ui-floating-box', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'new-post'
	      }
	    }
	  }, [_c('ui-button', {
	    attrs: {
	      "icon": "add",
	      "type": "button",
	      "primary": "",
	      "fab": "",
	      "big-icon": ""
	    }
	  })], 1)], 1), _vm._v(" "), _c('ui-grid', {
	    attrs: {
	      "name": "post",
	      "fields": _vm.fields,
	      "records": _vm.posts,
	      "actions": _vm.actions,
	      "converter": _vm.converter,
	      "paging": _vm.postPaging
	    },
	    on: {
	      "selectedsAction": _vm.removeSelecteds
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    class: _vm.cssClasses
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "module-header"
	  }, [_c('ui-title', {
	    attrs: {
	      "icon": _vm.icon
	    }
	  }, [_vm._v(_vm._s(_vm.title))])], 1)
	},staticRenderFns: []}

/***/ },
/* 274 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app",
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.ready) ? _c('div', [_c('ui-layout', {
	    class: {
	      'login-page': _vm.isLoginRoute()
	    }
	  }, [_c('ui-header'), _vm._v(" "), _c('ui-nav'), _vm._v(" "), _c('ui-content', [_c('breadcrumbs'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.transitionName,
	      "mode": _vm.transitionMode
	    },
	    on: {
	      "enter": _vm.$defaultEnterTransition
	    }
	  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
	    staticClass: "mdl-js-snackbar mdl-snackbar mdl-snackbar-large",
	    attrs: {
	      "id": "snackbar-message"
	    }
	  }, [_c('div', {
	    staticClass: "mdl-snackbar__text"
	  }), _vm._v(" "), _c('button', {
	    staticClass: "mdl-snackbar__action",
	    attrs: {
	      "type": "button"
	    }
	  })])], 1)], 1), _vm._v(" "), _c('ui-dialog', {
	    ref: "mainDialog"
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.cssClasses
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 276 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "not-found"
	  }, [_c('ui-title', {
	    attrs: {
	      "icon": "account_circle"
	    }
	  }, [_vm._v("Not found")]), _vm._v(" "), _c('p', [_vm._v("Ops, parece que essa página não existe!")]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home'
	      }
	    }
	  }, [_vm._v("Ir para página inicial")])], 1)
	},staticRenderFns: []}

/***/ },
/* 277 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "register"
	  }, [_c('ui-title', {
	    attrs: {
	      "icon": "assignment_ind"
	    }
	  }, [_vm._v("Register")]), _vm._v(" "), _c('div', {
	    class: {
	      'flip-container': true, 'flipped': _vm.success
	    }
	  }, [_c('div', {
	    staticClass: "flipper"
	  }, [_c('div', {
	    staticClass: "front"
	  }, [_c('form', {
	    attrs: {
	      "action": "#"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.sendForm($event)
	      }
	    }
	  }, [_c('ui-field-group', {
	    attrs: {
	      "invalid": _vm.name_error,
	      "value": _vm.name
	    }
	  }, [_c('ui-text', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    attrs: {
	      "name": "name",
	      "value": _vm.newsletter.name
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        _vm.name = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v("Nome")])], 1), _vm._v(" "), _c('ui-field-group', {
	    attrs: {
	      "invalid": _vm.email_error,
	      "value": _vm.email
	    }
	  }, [_c('ui-text', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "email",
	      "name": "email",
	      "value": _vm.newsletter.email
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        _vm.email = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v("E-mail")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "newsletter-submit-box"
	  }, [_c('ui-button', {
	    attrs: {
	      "with-icon": "send",
	      "colored": "",
	      "raised": "",
	      "disabled": _vm.disabled
	    }
	  }, [_vm._v("Enviar")])], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "back"
	  }, [_c('div', {
	    staticClass: "message-box"
	  }, [_c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  })]), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "icon": "chevron_left",
	      "type": "button",
	      "primary": "",
	      "fab": "",
	      "big-icon": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cleanForm($event)
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('ui-button', {
	    attrs: {
	      "icon": "add",
	      "type": "button",
	      "fab": "",
	      "big-icon": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.notificate($event)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "new-post"
	  }, [_c('ui-second-title', [_vm._v(_vm._s(_vm.$t('modules.posts.new')))]), _vm._v(" "), _c('post-form', {
	    attrs: {
	      "type": "create"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_c('ui-title', {
	    attrs: {
	      "icon": "account_balance"
	    }
	  }, [_vm._v("Home")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")])], 1)
	},staticRenderFns: []}

/***/ },
/* 280 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "about"
	  }, [_c('ui-title', {
	    attrs: {
	      "icon": "account_circle"
	    }
	  }, [_vm._v("About")]), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-grid"
	  }, [_c('div', {
	    staticClass: "mdl-cell mdl-cell--6-col"
	  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")])]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--6-col"
	  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis dolores numquam, facilis temporibus natus itaque, voluptatum aspernatur aut ducimus cupiditate recusandae odio doloremque expedita vel in debitis saepe repudiandae. Enim.")])])])
	}]}

/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', {
	    class: _vm.cssClasses
	  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
	},staticRenderFns: []}

/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [(_vm.ready) ? _c('div', [_c('ui-title', {
	    attrs: {
	      "icon": "account_circle"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('pages.login.title')))]), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "#"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.sendForm($event)
	      }
	    }
	  }, [_c('ui-field-group', {
	    attrs: {
	      "invalid": _vm.username_error,
	      "value": _vm.username
	    }
	  }, [_c('ui-text', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    attrs: {
	      "name": "username",
	      "value": _vm.user.username,
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        _vm.username = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('models.user.username')))])], 1), _vm._v(" "), _c('ui-field-group', {
	    attrs: {
	      "invalid": _vm.password_error,
	      "value": _vm.password
	    }
	  }, [_c('ui-text', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "value": _vm.user.password,
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        _vm.password = $event
	      }
	    }
	  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('models.user.password')))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "submit-box"
	  }, [_c('ui-button', {
	    attrs: {
	      "with-icon": "lock",
	      "colored": "",
	      "raised": "",
	      "disabled": _vm.disabled
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.enter')) + "\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "languages-box"
	  }, _vm._l((_vm.locales), function(item) {
	    return (_vm.locales) ? _c('a', {
	      class: {
	        'active': item.active
	      },
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.setLocale(item.locale)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(item.name))]) : _vm._e()
	  })), _vm._v(" "), _c('div', {
	    staticClass: "tip",
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('pages.login.tip'))
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    class: _vm.cssClasses,
	    attrs: {
	      "id": _vm.id,
	      "name": _vm.name
	    },
	    domProps: {
	      "value": _vm.value,
	      "value": _vm.value
	    },
	    on: {
	      "input": function($event) {
	        _vm.updateValue($event.target.value)
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    class: _vm.cssClasses,
	    attrs: {
	      "type": _vm.type,
	      "disabled": _vm.disabled
	    }
	  }, [(_vm.isWithIconSpecified) ? _c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v(_vm._s(_vm.withIcon))]) : _vm._e(), _vm._v(" "), _vm._t("default", [(_vm.isIconSpecified) ? _c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e()]), _vm._v(" "), (_vm.spinner) ? _c('ui-spinner', {
	    attrs: {
	      "singleColor": ""
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-layout-transparent mdl-layout mdl-js-layout"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('ui-title', {
	    attrs: {
	      "icon": "apps"
	    }
	  }, [_vm._v("Table")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "mdl-spinner mdl-js-spinner is-active"
	  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Lorem ipsum")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe deleniti, mollitia, accusantium atque suscipit officiis cupiditate doloremque vitae magni ducimus eaque maxime? Aut dicta culpa eligendi voluptatem quaerat iure nesciunt.")]), _vm._v(" "), _vm._m(1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-responsive-table-box"
	  }, [_c('table', {
	    staticClass: "mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "mdl-data-table__cell--non-numeric"
	  }, [_vm._v("Material")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Unit price")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "mdl-data-table__cell--non-numeric"
	  }, [_vm._v("Acrylic (Transparent)")]), _vm._v(" "), _c('td', [_vm._v("25")]), _vm._v(" "), _c('td', [_vm._v("$2.90")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "mdl-data-table__cell--non-numeric"
	  }, [_vm._v("Plywood (Birch)")]), _vm._v(" "), _c('td', [_vm._v("50")]), _vm._v(" "), _c('td', [_vm._v("$1.25")])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "mdl-data-table__cell--non-numeric"
	  }, [_vm._v("Laminate (Gold on Blue)")]), _vm._v(" "), _c('td', {
	    staticClass: "hello"
	  }, [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("$2.35")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-grid mdl-grid-negative"
	  }, [_c('div', {
	    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-cell--order-2-phone"
	  }, [_c('div', {
	    staticClass: "demo-card-wide mdl-card mdl-shadow--2dp"
	  }, [_c('div', {
	    staticClass: "mdl-card__title"
	  }, [_c('h2', {
	    staticClass: "mdl-card__title-text"
	  }, [_vm._v("Welcome 1")])]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-card__supporting-text"
	  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Mauris sagittis pellentesque lacus eleifend lacinia...\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-card__actions mdl-card--border"
	  }, [_c('a', {
	    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
	  }, [_vm._v("\n            Get Started\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-card__menu"
	  }, [_c('button', {
	    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
	  }, [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("share")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-cell--order-1-phone"
	  }, [_c('div', {
	    staticClass: "demo-card-wide mdl-card mdl-shadow--2dp"
	  }, [_c('div', {
	    staticClass: "mdl-card__title"
	  }, [_c('h2', {
	    staticClass: "mdl-card__title-text"
	  }, [_vm._v("Welcome 2")])]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-card__supporting-text"
	  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Mauris sagittis pellentesque lacus eleifend lacinia...\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-card__actions mdl-card--border"
	  }, [_c('a', {
	    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
	  }, [_vm._v("\n            Get Started\n          ")])]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-card__menu"
	  }, [_c('button', {
	    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
	  }, [_c('i', {
	    staticClass: "material-icons"
	  }, [_vm._v("share")])])])])])])
	}]}

/***/ },
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.61b4683e35abd9bc1c96.js